var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"微信支付","name":"first"}},[_c('Wxpay')],1),_c('el-tab-pane',{attrs:{"label":"支付宝支付","name":"second"}},[_c('Alipay')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }